import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import r from 'render-dom';
import styled from 'styled-components';

import Input from 'components/App/Dashboard/ui/Input';
import { usePlanContext } from 'hooks';

const Container = styled.section`
    margin-bottom: 30px;
`;

const Title = styled.div`
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
`;

const SubTitle = styled.div`
    color: #a0a0a0;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 20px;
`;

const propTypes = {
    form: ImmutablePropTypes.map.isRequired,
    selectedPlan: PropTypes.object,
    updateForm: PropTypes.func.isRequired,
};

export default function ProductSetup({ form, updateForm, validation }) {
    const [plan] = usePlanContext();
    const updateFormState = (key, value) => updateForm(form.set(key, value));

    return (
        r(Container, [
            r(Title, ['Let\'s add your first product.']),
            r(SubTitle, [
                `This will allow you to track your keyword rank position on amazon and launch
                campaigns much faster.`
            ]),
            r(Input, {
                label: 'Amazon url',
                meta: { error: validation.get('asin') },
                onChange: (e) => updateFormState('amazonUrl', e.target.value),
                placeholder: 'amazon.com/dp/B08GHTV5V3',
                value: form.get('amazonUrl', ''),
            }),
            r(Input, {
                isRendered: plan.get('keywords'),
                label: 'Track a keyword',
                meta: { error: validation.get('keyword') },
                onChange: (e) => updateFormState('keyword', e.target.value),
                placeholder: 'water bottle',
                value: form.get('keyword', ''),
            }),
        ])
    );
}

ProductSetup.propTypes = propTypes;
